import React, { useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import './MeteoData.css';
import { useTranslation } from 'react-i18next';

function MeteoData(props) {

    const { t } = useTranslation();
    var [MS, setMS] = useState([]);
    var [htmlMS, setHtmlMS] = useState(<></>);
    var idParque = (JSON.parse(sessionStorage.getItem("configuration"))[0].idSolarFarm);
    const { code } = props;
    const variablesAPedir = "name,timeStamp,radiationCellFixed,radiationPyranometerFixed,temperatureModuleFixed,radiationCellTrackers,radiationPyranometerTrackers,temperatureModuleTrackers,radiationPyranometerHorizontalTrackers,temperatureAmbient,pressure,humidity,windSpeed,windDirection,colorTimestamp";
    let number = 0;
    useEffect(() => {
        fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/meteorologicalStation?idSolarFarm=" + idParque + "&variables=" + variablesAPedir, { method: 'GET', credentials: 'include' })
            .then(async (dataMS) => { setMS(await dataMS.json()); })
            .catch(e => { console.log(e); })
        var interval1 = setInterval(function () {
            number++;
            if (code == sessionStorage.getItem("key")) { // No ha cambiado de página
                fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/meteorologicalStation?idSolarFarm=" + idParque + "&variables=" + variablesAPedir, { method: 'GET', credentials: 'include' })
                    .then(async (dataMS) => { setMS(await dataMS.json()); })
                    .catch(e => { console.log(e); })
            } else { // Ha cambiado de página. Cancela bucle
                clearInterval(interval1);
            }
        }, 30000)
    }, [number]);

    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        htmlMS = MS.map((datoMS, index) => {
            const { name, timeStamp, radiationCellFixed, radiationPyranometerFixed, temperatureModuleFixed, radiationCellTrackers, radiationPyranometerTrackers, temperatureModuleTrackers,
                radiationPyranometerHorizontalTrackers, temperatureAmbient, pressure, humidity, windSpeed, windDirection, colorTimestamp } = datoMS;
            return (
                <div className='col-12 col-sm-6'>
                    <h3>{name}</h3>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>{t('scada.solarFarm.meteo.data.readDate')}</th>
                                <th style={{ color: colorTimestamp }}>{timeStamp}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {radiationCellFixed ?
                                <tr>
                                    <td>{t('scada.solarFarm.meteo.data.irradiance')}</td>
                                    <td><strong>{radiationCellFixed}</strong></td>
                                </tr> : <></>}

                            {radiationPyranometerFixed ?
                                <tr>
                                    <td>{t('scada.solarFarm.meteo.data.irradiance2')}</td>
                                    <td><strong>{radiationPyranometerFixed}</strong></td>
                                </tr> : <></>}

                            {temperatureModuleFixed ?
                                <tr>
                                    <td>{t('scada.solarFarm.meteo.data.moduleTemperature')}</td>
                                    <td><strong>{temperatureModuleFixed} </strong></td>
                                </tr> : <></>}

                            {radiationCellTrackers ?
                                <tr>
                                    <td>{t('scada.solarFarm.meteo.data.irradiance3')}</td>
                                    <td><strong>{radiationCellTrackers}</strong></td>
                                </tr> : <></>}

                            {radiationPyranometerTrackers ?
                                <tr>
                                    <td>{t('scada.solarFarm.meteo.data.irradiance4')}</td>
                                    <td><strong>{radiationPyranometerTrackers}</strong></td>
                                </tr> : <></>}

                            {temperatureModuleTrackers ?
                                <tr>
                                    <td>{t('scada.solarFarm.meteo.data.trackerTemperature')}</td>
                                    <td><strong>{temperatureModuleTrackers} </strong></td>
                                </tr> : <></>}

                            {radiationPyranometerHorizontalTrackers ?
                                <tr>
                                    <td>{t('scada.solarFarm.meteo.data.horTracker')}</td>
                                    <td><strong>{radiationPyranometerHorizontalTrackers}</strong></td>
                                </tr> : <></>}

                            {temperatureAmbient ?
                                <tr>
                                    <td>{t('scada.solarFarm.meteo.data.ambTemperature')}</td>
                                    <td><strong>{temperatureAmbient}</strong></td>
                                </tr> : <></>}

                            {pressure ?
                                <tr >
                                    <td>{t('scada.solarFarm.meteo.data.press')}</td>
                                    <td><strong>{pressure}</strong></td>
                                </tr> : <></>}

                            {humidity ?
                                <tr>
                                    <td>{t('scada.solarFarm.meteo.data.humidity')}</td>
                                    <td><strong>{humidity}</strong></td>
                                </tr> : <></>}

                            {windSpeed ?
                                <tr>
                                    <td>{t('scada.solarFarm.meteo.data.velWind')}</td>
                                    <td><strong>{windSpeed}</strong></td>
                                </tr> : <></>}

                            {windDirection ?
                                <tr>
                                    <td>{t('scada.solarFarm.meteo.data.dirWind')}</td>
                                    <td><strong>{windDirection}</strong></td>
                                </tr> : <></>}
                        </tbody>
                    </Table>
                </div>
            );
        });
        setHtmlMS(htmlMS);
    }, [MS]);
    return (
        <div className='container-fluid' style={{ marginTop: '20px' }}>
            <div className='row'>
                {htmlMS}
            </div>
        </div>
    )
}

export default MeteoData